<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M88.6649 31.7439L88.5101 22.2124C88.4565 20.1644 86.8669 18.5272 84.9261 18.5212L46.3892 18.3546C44.3293 18.3426 42.6802 20.1585 42.7754 22.3255L46.2642 97.4586C46.3356 99.1672 47.6692 100.513 49.2885 100.519L81.0504 100.638H85.6882C87.5814 100.638 89.0876 99.0243 88.9804 97.1073L88.6589 30.9105"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M59.4221 19.2297C59.4221 19.2297 59.2792 22.0279 66.4234 22.0279C73.5676 22.0279 73.8533 19.456 73.8533 19.456L59.4221 19.2297Z"
            class="primary-fill primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M41.1152 27.767L43.6871 96.2261C43.6871 99.8042 46.2888 102.698 49.4918 102.698H77.1815C78.1638 102.698 79.0866 102.43 79.8963 101.947C83.7303 99.6851 80.9977 93.8745 76.9136 95.5415C75.8777 95.9642 75.3418 96.7441 75.0263 97.6073C73.1629 102.733 81.2596 115.182 87.868 113.759C97.2269 111.747 93.6964 88.302 98.7331 87.9508C101.001 87.79 103.026 92.5826 104.853 96.6191"
            class="accent-stroke"
            stroke-width="7.73953"
            stroke-miterlimit="10" />
        <path
            d="M78.8932 51.7238C78.1669 48.0803 76.095 45.2583 76.095 45.2583C76.095 45.2583 70.1535 42.6745 64.4262 45.2285C58.693 47.7826 57.5797 57.201 58.7644 61.9757C59.1336 63.476 59.6694 64.7143 60.3124 65.774C60.2588 68.4769 60.1278 73.5314 59.8837 74.1149L59.5443 74.9126L57.6035 76.5558C57.6035 76.5558 62.2175 81.8127 67.2482 82.2116C68.2126 82.289 68.9687 82.2414 69.5522 82.1223C71.0524 81.8127 71.7609 80.0743 70.9631 78.7645C70.7429 78.4073 70.6297 77.9965 70.6357 77.5738L70.6833 72.4598C73.3803 72.5908 76.1903 71.7156 77.7025 69.1794C80.2863 64.8453 79.6195 55.3614 78.8932 51.7178V51.7238Z"
            fill="white"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M60.3233 57.6237C60.3233 57.6237 62.0676 56.5521 63.1035 53.9444C64.1394 51.3428 63.7346 49.14 63.7346 49.14C63.7346 49.14 66.0386 48.5149 69.6583 49.1876C73.2781 49.8603 77.6122 50.8367 80.9104 48.4613C84.2087 46.0799 83.8693 42.865 82.0118 41.71C79.934 40.4181 76.225 41.7338 76.225 41.7338C76.225 41.7338 77.5348 40.1562 76.6537 39.406C75.7726 38.6559 73.0042 40.049 73.0042 40.049C73.0042 40.049 69.194 37.62 62.5856 38.6618C55.9713 39.7037 53.2922 44.6808 53.4648 49.902C53.6375 55.1232 56.0725 60.1122 56.0725 60.1122L60.3352 57.6296L60.3233 57.6237Z"
            class="primary-fill" />
        <path
            d="M59.4902 61.0172C59.4902 61.0172 60.0737 62.577 62.6456 64.1785C65.2175 65.7859 68.8074 66.7801 68.8074 66.7801L68.9563 65.5478C68.9563 65.5478 65.2294 64.3749 63.3957 62.8449C61.562 61.3148 61.2584 60.4099 61.2584 60.4099L59.4962 61.0172H59.4902Z"
            fill="white"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M69.2719 64.6131C71.177 64.3214 72.4035 65.7204 72.6357 66.6849C72.8738 67.6494 72.0701 68.8401 69.8196 68.1078C67.0215 67.1969 67.3668 64.9048 69.2719 64.6131Z"
            fill="white"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M72.7192 39.7811C72.7192 39.7811 72.5584 39.0072 70.5462 38.4475C69.3793 38.1261 67.8373 38.4416 67.8373 38.4416C67.8373 38.4416 62.8245 39.3941 59.0619 44.5737C56.9127 47.5266 56.0494 50.7713 55.7041 53.0098C52.1142 54.1469 50.4472 57.8559 50.6377 61.3923C50.8699 65.7919 54.4063 68.7865 58.6213 68.0007C67.8135 66.292 65.7417 53.8909 59.3 52.7478C59.6751 51.0392 60.4371 48.759 61.9672 46.842C67.4503 39.9597 72.7192 39.7811 72.7192 39.7811Z"
            fill="white"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
